import { FC } from 'react';

import { Svg, SvgProps } from './IconWrapper';

const OneToneIcons: Record<string, FC<SvgProps>> = {
  RealEstateUpdateHouseSync: (props) => (
    <Svg {...props} viewBox="0 0 140 140">
      <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
        <path
          d="M8.893,15.464a.5.5,0,0,0,.5.5h5.714a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,1,.5-.5h.143a.5.5,0,0,0,.325-.88l-4-3.428a.5.5,0,0,0-.65,0l-4,3.428a.5.5,0,0,0,.325.88h.143a.5.5,0,0,1,.5.5Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
        <path
          d="M5.387,12.647A.75.75,0,0,0,4.752,11.5H4.325a.5.5,0,0,1-.5-.565A8.242,8.242,0,0,1,18.47,6.882,1,1,0,1,0,20.038,5.64a10.24,10.24,0,0,0-18.23,5.406.5.5,0,0,1-.5.454H.751a.75.75,0,0,0-.636,1.147l2,3.2a.751.751,0,0,0,1.272,0Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
        <path
          d="M23.249,12.5a.75.75,0,0,0,.636-1.147l-2-3.2a.779.779,0,0,0-1.272,0l-2,3.2a.75.75,0,0,0,.635,1.147h.427a.5.5,0,0,1,.5.565A8.242,8.242,0,0,1,5.53,17.118,1,1,0,1,0,3.962,18.36a10.24,10.24,0,0,0,18.23-5.406.5.5,0,0,1,.5-.454Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </Svg>
  ),
  RoadSignWarning: (props) => (
    <Svg {...props} viewBox="0 0 16 16" fill="none">
      <>
        <path
          d="M8.87523 1.51672C8.7888 1.36026 8.66202 1.22982 8.50807 1.13899C8.35412 1.04815 8.17864 1.00024 7.9999 1.00024C7.82115 1.00024 7.64567 1.04815 7.49172 1.13899C7.33778 1.22982 7.21099 1.36026 7.12456 1.51672L0.624564 13.5167C0.540509 13.669 0.497611 13.8405 0.500103 14.0144C0.502595 14.1883 0.550391 14.3585 0.638773 14.5083C0.727156 14.6581 0.853068 14.7822 1.00408 14.8684C1.1551 14.9547 1.32599 15 1.4999 15.0001H14.4999C14.6738 15 14.8447 14.9547 14.9957 14.8684C15.1467 14.7822 15.2726 14.6581 15.361 14.5083C15.4494 14.3585 15.4972 14.1883 15.4997 14.0144C15.5022 13.8405 15.4593 13.669 15.3752 13.5167L8.87523 1.51672Z"
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 12C8.0663 12 8.12989 12.0263 8.17678 12.0732C8.22366 12.1201 8.25 12.1837 8.25 12.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 12.25C7.75 12.1837 7.77634 12.1201 7.82322 12.0732C7.87011 12.0263 7.9337 12 8 12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 12.5C7.9337 12.5 7.87011 12.4737 7.82322 12.4268C7.77634 12.3799 7.75 12.3163 7.75 12.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 12.25C8.25 12.3163 8.22366 12.3799 8.17678 12.4268C8.12989 12.4737 8.0663 12.5 8 12.5"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 10V5.5" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
      </>
    </Svg>
  ),
  Search: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12C5.791 12 4 10.209 4 8C4 5.791 5.791 4 8 4C10.209 4 12 5.791 12 8C12 10.209 10.209 12 8 12ZM17.707 16.293L12.887 11.473C13.585 10.492 14 9.296 14 8C14 4.687 11.313 2 8 2C4.687 2 2 4.687 2 8C2 11.313 4.687 14 8 14C9.296 14 10.492 13.585 11.473 12.887L16.293 17.707C16.488 17.902 16.744 18 17 18C17.256 18 17.512 17.902 17.707 17.707C18.098 17.316 18.098 16.684 17.707 16.293Z"
        fill="currentColor"
      />
    </Svg>
  ),
  CheckCircle: (props) => (
    /* TODO: Remove */
    <Svg {...props} viewBox="0 0 18 18" fill="none">
      <>
        <path
          d="M4.5 9.91722L6.3375 12.525C6.4072 12.6291 6.50076 12.715 6.61038 12.7757C6.72001 12.8364 6.84254 12.87 6.96778 12.8737C7.09301 12.8774 7.21733 12.8512 7.33038 12.7972C7.44344 12.7432 7.54196 12.663 7.61775 12.5632L13.5 5.12097"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.5625 8.99927C0.5625 11.237 1.45145 13.3831 3.03379 14.9655C4.61612 16.5478 6.76224 17.4368 9 17.4368C11.2378 17.4368 13.3839 16.5478 14.9662 14.9655C16.5486 13.3831 17.4375 11.237 17.4375 8.99927C17.4375 6.7615 16.5486 4.61539 14.9662 3.03305C13.3839 1.45072 11.2378 0.561768 9 0.561768C6.76224 0.561768 4.61612 1.45072 3.03379 3.03305C1.45145 4.61539 0.5625 6.7615 0.5625 8.99927V8.99927Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    </Svg>
  ),
  CircleTickMajor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Add: (props) => (
    <Svg {...props} viewBox="0 0 140 140">
      <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
        <path
          d="M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </Svg>
  ),
  DownloadCircle: (props) => (
    <Svg {...props}>
      <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm4.748,14.664-4,4.5a1,1,0,0,1-1.5,0l-4-4.5A1,1,0,0,1,8,13h2.25a.25.25,0,0,0,.25-.25V5.5a1.5,1.5,0,0,1,3,0v7.25a.25.25,0,0,0,.25.25H16a1,1,0,0,1,.748,1.664Z" />
    </Svg>
  ),
  CrossCircle: (props) => (
    <Svg {...props} viewBox="0 0 140 140">
      <g transform="matrix(10,0,0,10,0,0)">
        <path
          d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM9.651,8.591a.75.75,0,0,1-1.06,1.061L7,8.061,5.409,9.652a.75.75,0,1,1-1.06-1.061L5.94,7,4.349,5.409a.75.75,0,1,1,1.06-1.061L7,5.939,8.591,4.348a.75.75,0,0,1,1.06,1.061L8.06,7Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </Svg>
  ),
  CrossClose: (props) => (
    <Svg {...props} viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41425 6.00001L11.7072 1.70701C12.0982 1.31601 12.0982 0.684006 11.7072 0.293006C11.3162 -0.0979941 10.6842 -0.0979941 10.2933 0.293006L6.00025 4.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L4.58625 6.00001L0.29325 10.293C-0.09775 10.684 -0.09775 11.316 0.29325 11.707C0.48825 11.902 0.74425 12 1.00025 12C1.25625 12 1.51225 11.902 1.70725 11.707L6.00025 7.41401L10.2933 11.707C10.4882 11.902 10.7443 12 11.0002 12C11.2562 12 11.5122 11.902 11.7072 11.707C12.0982 11.316 12.0982 10.684 11.7072 10.293L7.41425 6.00001Z"
        fill="#59595F"
      />
    </Svg>
  ),
  CloseModal: (props) => (
    <Svg {...props} viewBox="64 64 896 896" fill="currentColor">
      <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
    </Svg>
  ),
  CaretDown: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 8L10 13L15 8H5Z" fill="currentColor" />
    </Svg>
  ),
  Email: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4C2.67157 4 2 4.67157 2 5.5V14.5C2 15.3284 2.67157 16 3.5 16H16.5C17.3284 16 18 15.3284 18 14.5V5.5C18 4.67157 17.3284 4 16.5 4H3.5ZM5.51452 6.14251C5.04094 5.85836 4.42668 6.01192 4.14254 6.4855C3.85839 6.95908 4.01195 7.57334 4.48553 7.85749L9.48553 10.8575C9.80222 11.0475 10.1978 11.0475 10.5145 10.8575L15.5145 7.85749C15.9881 7.57334 16.1417 6.95908 15.8575 6.4855C15.5734 6.01192 14.9591 5.85836 14.4855 6.14251L10 8.83381L5.51452 6.14251Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Ellipsis: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10C6 11.104 5.104 12 4 12C2.896 12 2 11.104 2 10C2 8.896 2.896 8 4 8C5.104 8 6 8.896 6 10ZM12 10C12 11.104 11.104 12 10 12C8.896 12 8 11.104 8 10C8 8.896 8.896 8 10 8C11.104 8 12 8.896 12 10ZM18 10C18 11.104 17.104 12 16 12C14.896 12 14 11.104 14 10C14 8.896 14.896 8 16 8C17.104 8 18 8.896 18 10Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Phone: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        d="M8.92926 6.39139L8.46203 4.05522C8.33953 3.44186 7.80055 3 7.17495 3H4.34616C3.59369 3 2.96721 3.6361 3.00133 4.3877C3.40469 13.2783 7.8128 16.6592 15.614 16.9987C16.3656 17.031 17 16.4072 17 15.6556V12.8251C17 12.1994 16.5581 11.6605 15.9448 11.538L13.6086 11.0707C13.0285 10.9544 12.4423 11.2414 12.1772 11.7707L11.7502 12.6238C10.0002 12.6238 7.37531 9.9989 7.37531 8.24895L8.22841 7.82197C8.75864 7.55773 9.04563 6.9715 8.92926 6.39139Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Location: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2C13.5913 2 16.5 4.864 16.5 8.4C16.5 8.51997 16.5 8.63202 16.4919 8.752C16.3863 11.592 14.875 14.848 10.6988 17.784C10.2844 18.072 9.71562 18.072 9.30125 17.784C5.125 14.848 3.61375 11.592 3.50812 8.752C3.5 8.632 3.5 8.52 3.5 8.4C3.5 4.864 6.40875 2 10 2ZM10 11C11.3807 11 12.5 9.88071 12.5 8.5C12.5 7.11929 11.3807 6 10 6C8.61929 6 7.5 7.11929 7.5 8.5C7.5 9.88071 8.61929 11 10 11Z"
        fill="currentColor"
      />
    </Svg>
  ),
  CircleInformation: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 4.71625e-07 10 9.53674e-07C4.486 1.43572e-06 -1.43572e-06 4.486 -9.53674e-07 10C-4.71625e-07 15.514 4.486 20 10 20ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V10C9 9.44772 9.44771 9 10 9C10.5523 9 11 9.44772 11 10V14ZM10 5C9.44771 5 9 5.44772 9 6C9 6.55229 9.44771 7 10 7C10.5523 7 11 6.55229 11 6C11 5.44772 10.5523 5 10 5Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Cancel: (props) => (
    <Svg {...props} viewBox="0 0 16 16" fill="none">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L6.81639 8.23061L2.29289 12.7541C1.90237 13.1446 1.90237 13.7778 2.29289 14.1683C2.68342 14.5588 3.31658 14.5588 3.70711 14.1683L8.23061 9.64482L12.7541 14.1683C13.1446 14.5588 13.7778 14.5588 14.1683 14.1683C14.5588 13.7778 14.5588 13.1446 14.1683 12.7541L9.64482 8.23061L14.1683 3.70713C14.5588 3.31661 14.5588 2.68344 14.1683 2.29292C13.7778 1.90239 13.1446 1.90239 12.7541 2.29292L8.23061 6.81639L3.70711 2.29289Z"
        fill="currentColor"
      />
    </Svg>
  ),
  CircleDisable: (props) => (
    <Svg {...props} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 6.706 2.416 5.51 3.115 4.529L11.471 12.885C10.49 13.584 9.294 14 8 14C4.691 14 2 11.309 2 8ZM14 8C14 9.294 13.584 10.49 12.885 11.471L4.529 3.115C5.51 2.416 6.706 2 8 2C11.309 2 14 4.691 14 8ZM0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8Z"
        fill="#8C9196"
      />
    </Svg>
  ),
  DiamondAlert: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7678 0.767755C10.7915 -0.208556 9.20859 -0.208555 8.23228 0.767756L0.767816 8.23222C-0.208495 9.20853 -0.208493 10.7914 0.767817 11.7678L8.23228 19.2322C9.20859 20.2085 10.7915 20.2085 11.7678 19.2322L19.2323 11.7678C20.2086 10.7914 20.2086 9.20853 19.2323 8.23222L11.7678 0.767755ZM8.99999 5.99999C8.99999 5.4477 9.4477 4.99999 9.99999 4.99999C10.5523 4.99999 11 5.4477 11 5.99999V9.99999C11 10.5523 10.5523 11 9.99999 11C9.4477 11 8.99999 10.5523 8.99999 9.99999V5.99999ZM11 14C11 14.5523 10.5523 15 9.99999 15C9.4477 15 8.99999 14.5523 8.99999 14C8.99999 13.4477 9.4477 13 9.99999 13C10.5523 13 11 13.4477 11 14Z"
      />
    </Svg>
  ),
  ChevronLeftMajor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7071 3.29289C14.0976 3.68342 14.0976 4.31658 13.7071 4.70711L8.41421 10L13.7071 15.2929C14.0976 15.6834 14.0976 16.3166 13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071L6.29289 10.7071C6.10536 10.5196 6 10.2652 6 10C6 9.73478 6.10536 9.48043 6.29289 9.29289L12.2929 3.29289C12.6834 2.90237 13.3166 2.90237 13.7071 3.29289Z"
      />
    </Svg>
  ),
  EditFilled: (props) => (
    <Svg {...props} viewBox="64 64 896 896" fill="none">
      <path
        fill="currentColor"
        d="M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
      />
    </Svg>
  ),
  MedicalFile: (props) => (
    <Svg {...props} viewBox="0 0 140 140">
      <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
        <path
          d="M21.5,7a1,1,0,0,0-.293-.707l-6-6A1,1,0,0,0,14.5,0H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2ZM5,22a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,5,2h8.5a.5.5,0,0,1,.5.5v3a2,2,0,0,0,2,2h3a.5.5,0,0,1,.5.5V21.5a.5.5,0,0,1-.5.5Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
        <path
          d="M17,12.214a.643.643,0,0,0-.643-.643H14.429a.5.5,0,0,1-.5-.5V9.143a.643.643,0,0,0-.643-.643H10.714a.642.642,0,0,0-.642.643v1.928a.5.5,0,0,1-.5.5H7.643A.643.643,0,0,0,7,12.214v2.572a.643.643,0,0,0,.643.643H9.572a.5.5,0,0,1,.5.5v1.928a.642.642,0,0,0,.642.643h2.572a.643.643,0,0,0,.643-.643V15.929a.5.5,0,0,1,.5-.5h1.928A.643.643,0,0,0,17,14.786Z"
          fill="currentColor"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </Svg>
  ),
  Refresh: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        d="M19.707 3.293C19.8 3.38579 19.8737 3.49599 19.924 3.61731C19.9743 3.73862 20.0002 3.86867 20.0002 4C20.0002 4.13133 19.9743 4.26138 19.924 4.38269C19.8737 4.50401 19.8 4.61421 19.707 4.707L16.707 7.707C16.6144 7.80018 16.5042 7.87413 16.3829 7.9246C16.2615 7.97506 16.1314 8.00103 16 8.00103C15.8686 8.00103 15.7385 7.97506 15.6172 7.9246C15.4958 7.87413 15.3857 7.80018 15.293 7.707C15.2001 7.61421 15.1263 7.50401 15.076 7.38269C15.0257 7.26138 14.9998 7.13133 14.9998 7C14.9998 6.86867 15.0257 6.73862 15.076 6.61731C15.1263 6.49599 15.2001 6.38579 15.293 6.293L16.586 5H7.00002C4.79402 5 3.00002 6.794 3.00002 9C3.00002 9.26522 2.89466 9.51957 2.70712 9.70711C2.51959 9.89464 2.26523 10 2.00002 10C1.7348 10 1.48045 9.89464 1.29291 9.70711C1.10537 9.51957 1.00002 9.26522 1.00002 9C1.00002 5.691 3.69102 3 7.00002 3H16.586L15.293 1.707C15.2002 1.61416 15.1265 1.50393 15.0763 1.38263C15.026 1.26132 15.0002 1.1313 15.0002 1C15.0002 0.868698 15.026 0.738681 15.0763 0.617374C15.1265 0.496067 15.2002 0.385844 15.293 0.293C15.3859 0.200155 15.4961 0.126507 15.6174 0.0762597C15.7387 0.0260125 15.8687 0.000150678 16 0.000150681C16.1313 0.000150683 16.2613 0.0260125 16.3826 0.0762597C16.504 0.126507 16.6142 0.200155 16.707 0.293L19.707 3.293ZM17 10C17.2652 10 17.5196 10.1054 17.7071 10.2929C17.8947 10.4804 18 10.7348 18 11C18 14.31 15.31 17 12 17H3.41402L4.70702 18.293C4.89453 18.4805 4.99987 18.7348 4.99987 19C4.99987 19.2652 4.89453 19.5195 4.70702 19.707C4.51951 19.8945 4.26519 19.9998 4.00002 19.9998C3.73484 19.9998 3.48053 19.8945 3.29302 19.707L0.293018 16.707C0.200072 16.6142 0.126335 16.504 0.0760238 16.3827C0.0257131 16.2614 -0.000183105 16.1313 -0.000183105 16C-0.000183105 15.8687 0.0257131 15.7386 0.0760238 15.6173C0.126335 15.496 0.200072 15.3858 0.293018 15.293L3.29302 12.293C3.38586 12.2002 3.49609 12.1265 3.61739 12.0763C3.7387 12.026 3.86872 12.0002 4.00002 12.0002C4.13132 12.0002 4.26134 12.026 4.38264 12.0763C4.50395 12.1265 4.61417 12.2002 4.70702 12.293C4.79986 12.3858 4.87351 12.4961 4.92376 12.6174C4.97401 12.7387 4.99987 12.8687 4.99987 13C4.99987 13.1313 4.97401 13.2613 4.92376 13.3826C4.87351 13.5039 4.79986 13.6142 4.70702 13.707L3.41402 15H12C14.206 15 16 13.206 16 11C16 10.7348 16.1054 10.4804 16.2929 10.2929C16.4804 10.1054 16.7348 10 17 10Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Copy: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <>
        <path
          d="M7.5 2C6.67157 2 6 2.67157 6 3.5V13C6 13.5523 6.44771 14 7 14H16.5C17.3284 14 18 13.3284 18 12.5V3.5C18 2.67157 17.3284 2 16.5 2H7.5Z"
          fill="currentColor"
        />
        <path
          d="M3.5 6H4V16H14V16.5C14 17.3284 13.3284 18 12.5 18H3.5C2.67157 18 2 17.3284 2 16.5V7.5C2 6.67157 2.67157 6 3.5 6Z"
          fill="currentColor"
        />
      </>
    </Svg>
  ),
  Duplicate: (props) => (
    <Svg {...props} viewBox="0 0 15 18" fill="none">
      <path
        d="M11 0.75H2C1.175 0.75 0.5 1.425 0.5 2.25V12.75H2V2.25H11V0.75ZM10.25 3.75H5C4.175 3.75 3.5075 4.425 3.5075 5.25L3.5 15.75C3.5 16.575 4.1675 17.25 4.9925 17.25H13.25C14.075 17.25 14.75 16.575 14.75 15.75V8.25L10.25 3.75ZM5 15.75V5.25H9.5V9H13.25V15.75H5Z"
        fill="currentColor"
      />
    </Svg>
  ),
  Archive: (props) => (
    <Svg {...props} viewBox="0 0 14 14" fill="none">
      <>
        <path
          d="M1.5 0C0.671573 0 0 0.671573 0 1.5V3H14V1.5C14 0.671573 13.3284 0 12.5 0H1.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 12.5C1 13.3284 1.67157 14 2.5 14H11.5C12.3284 14 13 13.3284 13 12.5V5H1V12.5ZM4 8H10V10H4V8Z"
          fill="currentColor"
        />
      </>
    </Svg>
  ),
  Trash: (props) => (
    <Svg {...props} viewBox="0 0 14 15" fill="none">
      <>
        <path
          d="M5 1.99388C5 0.892691 5.89543 0 7 0C8.10457 0 9 0.892691 9 1.99388H13C13.5523 1.99388 14 2.44023 14 2.99082C14 3.54142 13.5523 3.98776 13 3.98776H1C0.447716 3.98776 0 3.54142 0 2.99082C0 2.44023 0.447715 1.99388 1 1.99388H5Z"
          fill="currentColor"
        />
        <path
          d="M2 12.5076V6H4V12.5076C4 12.7829 4.22386 13.0061 4.5 13.0061H6V6H8L8 13.0061H9.5C9.77614 13.0061 10 12.7829 10 12.5076V6H12V12.5076C12 13.8841 10.8807 15 9.5 15H4.5C3.11929 15 2 13.8841 2 12.5076Z"
          fill="currentColor"
        />
      </>
    </Svg>
  ),
  MoveInbox: (props) => (
    <Svg {...props} viewBox="0 0 16 16" fill="none">
      <>
        <path
          d="M9 1C9 0.447715 8.55228 0 8 0C7.44772 0 7 0.447715 7 1V6.58579L5.70711 5.29289C5.31658 4.90237 4.68342 4.90237 4.29289 5.29289C3.90237 5.68342 3.90237 6.31658 4.29289 6.70711L7.29289 9.70711C7.68342 10.0976 8.31658 10.0976 8.70711 9.70711L11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L9 6.58579V1Z"
          fill="currentColor"
        />
        <path
          d="M2 7H0V15C0 15.5523 0.447715 16 1 16H15C15.5523 16 16 15.5523 16 15V7H14V11H11.618C11.2393 11 10.893 11.214 10.7236 11.5528L10 13H6L5.27639 11.5528C5.107 11.214 4.76074 11 4.38197 11H2V7Z"
          fill="currentColor"
        />
      </>
    </Svg>
  ),
  TickMinor: (props) => (
    <Svg {...props} viewBox="0 0 16 16" fill="none">
      <>
        <path
          d="M2 7.4306L6.44444 12.9862"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14.2328 3L6.45501 13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </>
    </Svg>
  ),
  DoubleTickMinor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.29325 14.7066L1.29325 11.7066C0.90225 11.3156 0.90225 10.6836 1.29325 10.2926C1.68425 9.90159 2.31625 9.90159 2.70725 10.2926L4.94325 12.5286L11.2413 5.34959C11.6012 4.92959 12.2323 4.88159 12.6503 5.24059C13.0703 5.60059 13.1192 6.23059 12.7592 6.64959L5.75925 14.6496C5.57825 14.8616 5.31625 14.9876 5.03825 14.9986C4.73525 14.9996 4.48025 14.8946 4.29325 14.7066Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2933 14.7066L7.29325 11.7066C6.90225 11.3156 6.90225 10.6836 7.29325 10.2926C7.68425 9.90159 8.31625 9.90159 8.70725 10.2926L10.9432 12.5286L17.2413 5.34959C17.6012 4.92959 18.2323 4.88159 18.6503 5.24059C19.0703 5.60059 19.1192 6.23059 18.7592 6.64959L11.7593 14.6496C11.5782 14.8616 11.3162 14.9876 11.0382 14.9986C10.7352 14.9996 10.4803 14.8946 10.2933 14.7066Z"
          fill="currentColor"
        />
      </>
    </Svg>
  ),
  CircleAlertMajor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM9 6C9 5.44772 9.44771 5 10 5C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10V6ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15Z"
        fill="currentColor"
      />
    </Svg>
  ),
  InboxMajor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 1A1.5 1.5 0 001 2.5v15A1.5 1.5 0 002.5 19h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0017.5 1h-15zM3 3v11h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 002.927-.001l.111-.119C12.112 14.662 12.725 14 13.5 14H17V3H3z"
        fill="currentColor"
      />
    </Svg>
  ),
  SelectMinor: (props) => (
    <Svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 16L6 12H14L10 16ZM10 4L14 8H6L10 4Z"
        fill="currentColor"
      />
    </Svg>
  ),
  DocumentGroup: (props) => (
    <Svg {...props} viewBox="0 0 21 21" fill="none">
      <path
        transform="translate(0,1.5)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.517 1.449H18.62a.69.69 0 01.69.69v9.654h1.38V2.138A2.069 2.069 0 0018.62.07H5.517v1.38zm11.035 2.034H2.759v-1.38h13.793a2.07 2.07 0 012.069 2.07v9.654h-1.38V4.172a.69.69 0 00-.69-.69zm-1.427 2.406H1.375v9.722h13.75V5.89zM1.375 4.5C.615 4.5 0 5.122 0 5.889v9.722C0 16.378.616 17 1.375 17h13.75c.76 0 1.375-.622 1.375-1.389V5.89c0-.767-.616-1.389-1.375-1.389H1.375z"
        fill="currentColor"
      />
    </Svg>
  ),
  QuestionCircleOutlined: (props) => (
    <svg {...props} viewBox="64 64 896 896" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
      />
    </svg>
  ),
  QuestionMarkMinor: (props) => (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 12.0625C7.65469 12.0625 7.375 11.7828 7.375 11.4375C7.375 11.0922 7.65469 10.8125 8 10.8125C8.34531 10.8125 8.625 11.0922 8.625 11.4375C8.625 11.7828 8.34531 12.0625 8 12.0625ZM8.98281 8.63281C8.84131 8.68746 8.71955 8.78347 8.63343 8.90834C8.54731 9.03321 8.50081 9.18113 8.5 9.33281V9.6875C8.5 9.75625 8.44375 9.8125 8.375 9.8125L7.625 9.8125C7.55625 9.8125 7.5 9.75625 7.5 9.6875V9.35156C7.5 8.99062 7.60469 8.63437 7.81094 8.3375C8.0125 8.04687 8.29375 7.825 8.625 7.69844C9.15625 7.49375 9.5 7.04844 9.5 6.5625C9.5 5.87344 8.82656 5.3125 8 5.3125C7.17344 5.3125 6.5 5.87344 6.5 6.5625V6.68125C6.5 6.75 6.44375 6.80625 6.375 6.80625H5.625C5.55625 6.80625 5.5 6.75 5.5 6.68125V6.5625C5.5 5.94844 5.76875 5.375 6.25625 4.94844C6.725 4.5375 7.34375 4.3125 8 4.3125C8.65625 4.3125 9.275 4.53906 9.74375 4.94844C10.2312 5.375 10.5 5.94844 10.5 6.5625C10.5 7.46562 9.90469 8.27812 8.98281 8.63281Z"
        fill="#434343"
      />
    </svg>
  ),
  Check: (props) => (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29325 14.7066L4.29325 11.7066C3.90225 11.3156 3.90225 10.6836 4.29325 10.2926C4.68425 9.90159 5.31625 9.90159 5.70725 10.2926L7.94325 12.5286L14.2413 5.34959C14.6012 4.92959 15.2323 4.88159 15.6503 5.24059C16.0703 5.60059 16.1192 6.23059 15.7592 6.64959L8.75925 14.6496C8.57825 14.8616 8.31625 14.9876 8.03825 14.9986C7.73525 14.9996 7.48025 14.8946 7.29325 14.7066Z"
      />
    </svg>
  ),
  BellAdd: (props) => (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0405 1C11.0405 0.447716 10.5746 0 10 0C9.4254 0 8.95952 0.447716 8.95952 1V3C8.95952 3.01435 8.96003 3.02863 8.96079 3.04284L8.96308 3.0824C6.00878 3.55709 3.75711 6.02583 3.75711 9C3.75711 12.0933 3.10681 13.312 2.09376 15.2103L2.05769 15.2781C1.88115 15.6088 2.13111 16 2.51798 16H17.482C17.8689 16 18.1189 15.6088 17.9423 15.2781L17.9062 15.2103C16.8932 13.312 16.2429 12.0933 16.2429 9C16.2429 6.02583 13.9912 3.55709 11.0369 3.0824L11.039 3.05341L11.04 3.0317L11.0405 3V1ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10 20C11.1492 20 12.081 19.1046 12.081 18H7.91904C7.91904 19.1046 8.8508 20 10 20Z"
        fill="currentColor"
      />
    </svg>
  ),
  BellCheck: (props) => (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0405 1C11.0405 0.447716 10.5746 0 10 0C9.4254 0 8.95952 0.447716 8.95952 1V3C8.95952 3.01435 8.96003 3.02863 8.96079 3.04284L8.96308 3.0824C6.00878 3.55709 3.75711 6.02583 3.75711 9C3.75711 12.0933 3.10681 13.312 2.09376 15.2103L2.05769 15.2781C1.88115 15.6088 2.13111 16 2.51798 16H17.482C17.8689 16 18.1189 15.6088 17.9423 15.2781L17.9062 15.2103C16.8932 13.312 16.2429 12.0933 16.2429 9C16.2429 6.02583 13.9912 3.55709 11.0369 3.0824L11.039 3.05341L11.04 3.0317L11.0405 3V1ZM9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7V9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H11V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V11H7C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9H9V7Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10 20C11.1492 20 12.081 19.1046 12.081 18H7.91904C7.91904 19.1046 8.8508 20 10 20Z"
        fill="currentColor"
      />
    </svg>
  ),
  BulletList: (props) => (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm0 5a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm-1 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm-2-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="currentColor"
      />
    </svg>
  ),
  Text: (props) => (
    <svg {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 9.75H0V11.25H7.5V9.75ZM12 3.75H0V5.25H12V3.75ZM0 8.25H12V6.75H0V8.25ZM0 0.75V2.25H12V0.75H0Z"
        fill="#858B93"
      />
    </svg>
  ),
  Replace: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM13.0544 10.9508C12.9179 11.2364 12.5434 11.2744 12.3196 11.0506L12.0251 10.7561C11.8694 10.6004 11.8377 10.3625 11.9184 10.1577C12.3652 9.0242 12.1477 7.69266 11.232 6.777C10.611 6.156 9.81 5.85 9 5.85C8.96989 5.85 8.95541 5.89541 8.9767 5.9167L9.54645 6.48645C9.74171 6.68171 9.74171 6.99829 9.54645 7.19355L9.29955 7.44045C9.10429 7.63571 8.78771 7.63571 8.59245 7.44045L6.75255 5.60055C6.55729 5.40529 6.55729 5.08871 6.75255 4.89345L8.59245 3.05355C8.78771 2.85829 9.10429 2.85829 9.29955 3.05355L9.54645 3.30045C9.74171 3.49571 9.74171 3.81229 9.54645 4.00755L9.37366 4.18035C9.2482 4.3058 9.33614 4.52655 9.5125 4.54594C10.4899 4.65342 11.4346 5.07037 12.186 5.814C13.5653 7.20139 13.8547 9.2763 13.0544 10.9508ZM11.2474 12.3994C11.4427 12.5947 11.4427 12.9113 11.2474 13.1066L9.40755 14.9464C9.21229 15.1417 8.89571 15.1417 8.70045 14.9464L8.24142 14.4874C8.16332 14.4093 8.16332 14.2827 8.24142 14.2046L8.61737 13.8286C8.74283 13.7032 8.6549 13.482 8.47865 13.4617C7.50824 13.35 6.56583 12.9198 5.823 12.177C4.34438 10.6984 4.11191 8.44715 5.1176 6.72432C5.18143 6.61499 5.33083 6.59983 5.42035 6.68935L5.97493 7.24393C6.13059 7.39959 6.16231 7.63747 6.08158 7.84228C5.63478 8.9758 5.85234 10.3073 6.768 11.223C7.28205 11.737 7.93391 12.0354 8.61114 12.1131C8.78509 12.1331 8.86937 11.9294 8.74557 11.8056L8.45355 11.5136C8.25829 11.3183 8.25829 11.0017 8.45355 10.8064L8.70045 10.5596C8.89571 10.3643 9.21229 10.3643 9.40755 10.5596L11.2474 12.3994Z"
        fill="#00A0AC"
      />
    </svg>
  ),
  Paperclip: (props) => (
    <svg {...props} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 4.00001C15.5523 4.00001 16 4.44773 16 5.00002C15.9999 9.4999 15.9991 13.9998 15.9997 18.4997C15.9998 19.3282 15.3282 20 14.4996 20C10.1664 19.9999 5.83313 20 1.49988 20C0.671451 20 -0.000122285 19.3284 -0.000119359 18.5C-9.93474e-05 12.8333 2.60274e-05 7.16667 7.46013e-05 1.49999C8.17024e-05 0.671569 0.671653 1.22923e-06 1.50008 2.74558e-06L5.99997 1.09822e-05V2.00001H1.99997V18H14V5.00002C14 4.44773 14.4477 4.00001 15 4.00001Z"
        fill="#595C5F"
      />
      <path
        d="M5.99997 5.00001V11C5.99997 12.206 6.79897 14 8.99997 14C11.201 14 12 12.206 12 11V3.00001C12 1.79402 11.201 1.09822e-05 8.99997 1.09822e-05H7.99997V2.00001H8.99997C9.80497 2.00001 9.98798 2.55 9.99997 3.00001V10.988C9.98798 11.45 9.80497 12 8.99997 12C8.19498 12 8.01197 11.45 7.99997 11V5.00001C7.99997 4.73481 7.89461 4.48042 7.70708 4.29292C7.51955 4.10536 7.26519 4.00001 6.99997 4.00001C6.73476 4.00001 6.4804 4.10536 6.29287 4.29292C6.10533 4.48042 5.99997 4.73481 5.99997 5.00001Z"
        fill="#595C5F"
      />
    </svg>
  ),
  Lock: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.625 8.15625H13.4297V4.21875C13.4297 2.97598 12.4225 1.96875 11.1797 1.96875H6.82031C5.57754 1.96875 4.57031 2.97598 4.57031 4.21875V8.15625H3.375C3.06387 8.15625 2.8125 8.40762 2.8125 8.71875V15.4688C2.8125 15.7799 3.06387 16.0312 3.375 16.0312H14.625C14.9361 16.0312 15.1875 15.7799 15.1875 15.4688V8.71875C15.1875 8.40762 14.9361 8.15625 14.625 8.15625ZM5.83594 4.21875C5.83594 3.67559 6.27715 3.23438 6.82031 3.23438H11.1797C11.7229 3.23438 12.1641 3.67559 12.1641 4.21875V8.15625H5.83594V4.21875ZM13.9219 14.7656H4.07812V9.42188H13.9219V14.7656ZM8.50781 12.3223V13.2539C8.50781 13.3313 8.57109 13.3945 8.64844 13.3945H9.35156C9.42891 13.3945 9.49219 13.3313 9.49219 13.2539V12.3223C9.63729 12.2181 9.74559 12.0706 9.80151 11.9009C9.85743 11.7313 9.85807 11.5482 9.80335 11.3782C9.74863 11.2082 9.64137 11.0599 9.49701 10.9547C9.35265 10.8495 9.17863 10.7928 9 10.7928C8.82137 10.7928 8.64735 10.8495 8.50299 10.9547C8.35863 11.0599 8.25137 11.2082 8.19665 11.3782C8.14193 11.5482 8.14257 11.7313 8.19849 11.9009C8.25441 12.0706 8.36271 12.2181 8.50781 12.3223Z"
        fill="#57606B"
      />
    </svg>
  ),
  ChatBubble: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.15635 9C8.15635 9.22378 8.24524 9.43839 8.40348 9.59662C8.56171 9.75485 8.77632 9.84375 9.0001 9.84375C9.22388 9.84375 9.43849 9.75485 9.59672 9.59662C9.75495 9.43839 9.84385 9.22378 9.84385 9C9.84385 8.77622 9.75495 8.56161 9.59672 8.40338C9.43849 8.24514 9.22388 8.15625 9.0001 8.15625C8.77632 8.15625 8.56171 8.24514 8.40348 8.40338C8.24524 8.56161 8.15635 8.77622 8.15635 9V9ZM11.672 9C11.672 9.22378 11.7609 9.43839 11.9191 9.59662C12.0773 9.75485 12.2919 9.84375 12.5157 9.84375C12.7395 9.84375 12.9541 9.75485 13.1123 9.59662C13.2706 9.43839 13.3595 9.22378 13.3595 9C13.3595 8.77622 13.2706 8.56161 13.1123 8.40338C12.9541 8.24514 12.7395 8.15625 12.5157 8.15625C12.2919 8.15625 12.0773 8.24514 11.9191 8.40338C11.7609 8.56161 11.672 8.77622 11.672 9ZM4.64072 9C4.64072 9.22378 4.72962 9.43839 4.88785 9.59662C5.04609 9.75485 5.2607 9.84375 5.48447 9.84375C5.70825 9.84375 5.92286 9.75485 6.0811 9.59662C6.23933 9.43839 6.32822 9.22378 6.32822 9C6.32822 8.77622 6.23933 8.56161 6.0811 8.40338C5.92286 8.24514 5.70825 8.15625 5.48447 8.15625C5.2607 8.15625 5.04609 8.24514 4.88785 8.40338C4.72962 8.56161 4.64072 8.77622 4.64072 9V9ZM16.2634 5.94844C15.8661 5.00449 15.2966 4.15723 14.5706 3.42949C13.8497 2.70597 12.9939 2.13086 12.0517 1.73672C11.0849 1.33066 10.0583 1.125 9.0001 1.125H8.96494C7.89971 1.13027 6.86787 1.34121 5.89756 1.75605C4.96338 2.15424 4.1156 2.73037 3.40147 3.45234C2.68252 4.17832 2.11826 5.02207 1.72803 5.9625C1.32373 6.93633 1.11983 7.97168 1.1251 9.03691C1.13106 10.2577 1.41987 11.4604 1.96885 12.5508V15.2227C1.96885 15.4371 2.05404 15.6428 2.20568 15.7944C2.35732 15.9461 2.56299 16.0312 2.77744 16.0312H5.45108C6.54144 16.5802 7.74419 16.869 8.96494 16.875H9.00186C10.0548 16.875 11.0761 16.6711 12.0376 16.2721C12.9751 15.8826 13.8277 15.3142 14.5478 14.5986C15.2737 13.8797 15.845 13.0395 16.244 12.1025C16.6589 11.1322 16.8698 10.1004 16.8751 9.03516C16.8804 7.96465 16.673 6.92578 16.2634 5.94844V5.94844ZM13.6073 13.6477C12.3751 14.8676 10.7403 15.5391 9.0001 15.5391H8.97022C7.91026 15.5338 6.85733 15.2701 5.92744 14.7744L5.77979 14.6953H3.30479V12.2203L3.22569 12.0727C2.72998 11.1428 2.46631 10.0898 2.46104 9.02988C2.45401 7.27734 3.12373 5.63203 4.35244 4.39277C5.5794 3.15352 7.21944 2.46797 8.97197 2.46094H9.00186C9.88076 2.46094 10.7333 2.63145 11.5366 2.96895C12.3206 3.29766 13.0237 3.77051 13.6284 4.3752C14.2313 4.97812 14.706 5.68301 15.0347 6.46699C15.3757 7.2791 15.5462 8.14043 15.5427 9.02988C15.5321 10.7807 14.8448 12.4207 13.6073 13.6477V13.6477Z"
        fill="currentColor"
      />
    </svg>
  ),
  Scissors: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.23 4.73C6.4025 4.355 6.5 3.9425 6.5 3.5C6.5 1.8425 5.1575 0.5 3.5 0.5C1.8425 0.5 0.5 1.8425 0.5 3.5C0.5 5.1575 1.8425 6.5 3.5 6.5C3.9425 6.5 4.355 6.4025 4.73 6.23L6.5 8L4.73 9.77C4.355 9.5975 3.9425 9.5 3.5 9.5C1.8425 9.5 0.5 10.8425 0.5 12.5C0.5 14.1575 1.8425 15.5 3.5 15.5C5.1575 15.5 6.5 14.1575 6.5 12.5C6.5 12.0575 6.4025 11.645 6.23 11.27L8 9.5L13.25 14.75H15.5V14L6.23 4.73ZM3.5 5C2.675 5 2 4.3325 2 3.5C2 2.6675 2.675 2 3.5 2C4.325 2 5 2.6675 5 3.5C5 4.3325 4.325 5 3.5 5ZM3.5 14C2.675 14 2 13.3325 2 12.5C2 11.6675 2.675 11 3.5 11C4.325 11 5 11.6675 5 12.5C5 13.3325 4.325 14 3.5 14ZM8 8.375C7.79 8.375 7.625 8.21 7.625 8C7.625 7.79 7.79 7.625 8 7.625C8.21 7.625 8.375 7.79 8.375 8C8.375 8.21 8.21 8.375 8 8.375ZM13.25 1.25L8.75 5.75L10.25 7.25L15.5 2V1.25H13.25Z"
        fill="currentColor"
      />
    </svg>
  ),
  Exclamation: (props) => (
    <svg {...props} viewBox="4 4 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"
        fill="currentColor"
      />
    </svg>
  ),
  Pipe: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0V11.5C1 14.8137 3.68629 17.5 7 17.5H18" stroke="#BFBFBF" />
    </svg>
  ),
  Incognito: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.99"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00967 1.66968C7.66984 1.66382 10.33 1.66968 12.9901 1.68726C13.5594 1.83477 13.952 2.18047 14.1679 2.72437C14.4807 4.23598 14.7913 5.7477 15.0995 7.25952C15.5678 7.28881 16.0366 7.30639 16.5058 7.31226C16.8475 7.47714 16.9588 7.74081 16.8398 8.10327C16.744 8.28109 16.5975 8.39243 16.4003 8.43726C11.4667 8.46071 6.5331 8.46071 1.59952 8.43726C1.21332 8.33172 1.05512 8.07975 1.12491 7.6814C1.19027 7.49883 1.31332 7.37578 1.49405 7.31226C1.96265 7.29468 2.4314 7.28881 2.9003 7.29468C3.20228 5.74376 3.52453 4.19689 3.8671 2.65405C4.09319 2.14051 4.47403 1.81238 5.00967 1.66968Z"
        fill="#595959"
      />
      <path
        opacity="0.988"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3064 9.54502C6.01999 9.42574 7.23288 10.1406 7.94508 11.6896C8.02558 11.9061 8.07832 12.1288 8.10328 12.3575C8.68968 12.3692 9.27563 12.3575 9.86109 12.3224C10.2215 10.7724 11.1825 9.85246 12.7439 9.5626C14.4583 9.42626 15.6712 10.1353 16.3826 11.6896C16.9078 13.4068 16.4449 14.7838 14.9939 15.8204C13.9438 16.3853 12.8657 16.4439 11.7595 15.9962C10.7315 15.4835 10.0987 14.6632 9.86109 13.5353C9.27528 13.5177 8.68933 13.5118 8.10328 13.5177C7.82213 14.8477 7.03699 15.7325 5.74781 16.172C4.10622 16.5509 2.8113 16.0529 1.86304 14.6778C1.16997 13.3565 1.24028 12.0791 2.07398 10.8458C2.65849 10.1347 3.40263 9.70111 4.3064 9.54502Z"
        fill="#595959"
      />
    </svg>
  ),
  IncognitoOutlined: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.99"
        d="M14.6096 7.3594L14.6861 7.73465L15.0683 7.75855C15.5008 7.78559 15.9337 7.80283 16.3669 7.81025C16.3771 7.81877 16.3824 7.825 16.3848 7.82828C16.3861 7.83546 16.388 7.85704 16.3782 7.89945C16.3644 7.91695 16.3489 7.92881 16.3284 7.93759C11.4449 7.96058 6.56126 7.96059 1.67769 7.93762C1.63727 7.92209 1.62025 7.90847 1.61478 7.90306C1.612 7.89541 1.60571 7.87056 1.61058 7.81767C1.61333 7.81326 1.6157 7.81023 1.61749 7.80818C2.0429 7.79383 2.46841 7.78931 2.89404 7.79464L3.31132 7.79986L3.39108 7.39024C3.68889 5.86075 4.00647 4.33522 4.34385 2.81362C4.50152 2.48092 4.73928 2.27468 5.08021 2.16953C7.69371 2.16397 10.3072 2.16973 12.9207 2.18681C13.2916 2.29694 13.5366 2.5166 13.6877 2.87119C13.9972 4.36716 14.3046 5.86323 14.6096 7.3594ZM16.3863 7.83091C16.3863 7.83092 16.3859 7.83031 16.3853 7.82904C16.3861 7.83026 16.3864 7.8309 16.3863 7.83091ZM16.3846 7.82733C16.3841 7.82614 16.384 7.8255 16.384 7.82548L16.3846 7.82733ZM1.61265 7.90057C1.6127 7.90055 1.61323 7.9011 1.61406 7.90233C1.61301 7.90122 1.61259 7.9006 1.61265 7.90057ZM1.61519 7.90411C1.61579 7.90515 1.61602 7.90571 1.61598 7.90574L1.61519 7.90411Z"
        stroke="#434343"
      />
      <path
        opacity="0.988"
        d="M7.60623 12.4118L7.65391 12.8486L8.0933 12.8574C8.69304 12.8694 9.2923 12.8574 9.89103 12.8215L10.2636 12.7991L10.3481 12.4356C10.5107 11.7364 10.8004 11.2117 11.1979 10.8311C11.5906 10.4552 12.1184 10.1913 12.8096 10.059C13.576 10.0021 14.1925 10.1347 14.687 10.4238C15.1798 10.7118 15.5936 11.1798 15.9141 11.8676C16.1439 12.6365 16.1439 13.2903 15.9554 13.8509C15.767 14.4113 15.3735 14.9285 14.7292 15.3949C13.8252 15.8723 12.9173 15.9201 11.9653 15.54C11.0849 15.0954 10.5553 14.4049 10.3504 13.4322L10.2693 13.0473L9.87609 13.0355C9.28362 13.0177 8.691 13.0118 8.09827 13.0177L7.69706 13.0217L7.61409 13.4143C7.37123 14.5632 6.71861 15.3054 5.61045 15.6905C4.8766 15.8559 4.25496 15.8198 3.72491 15.616C3.19641 15.4127 2.71646 15.0263 2.29191 14.4188C1.99032 13.8345 1.86623 13.2828 1.89521 12.7563C1.92429 12.2281 2.1092 11.6927 2.47508 11.1454C2.97591 10.5438 3.6005 10.1798 4.36668 10.0421C5.13326 9.99265 5.75114 10.13 6.24739 10.4224C6.74466 10.7155 7.16118 11.1888 7.48272 11.881C7.54536 12.0536 7.58642 12.2303 7.60623 12.4118Z"
        stroke="#434343"
      />
    </svg>
  ),
  EyeInvisible: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5622 8.54687C15.9442 7.24503 15.2089 6.18331 14.3561 5.36171L13.4617 6.25609C14.191 6.95306 14.8263 7.86484 15.3756 9.00038C13.9131 12.0273 11.8371 13.4652 9.00004 13.4652C8.14844 13.4652 7.36404 13.3341 6.64686 13.0718L5.67777 14.0409C6.67387 14.5009 7.78129 14.7309 9.00004 14.7309C12.3786 14.7309 14.8993 12.9713 16.5622 9.45214C16.629 9.31061 16.6637 9.15603 16.6637 8.99951C16.6637 8.84298 16.629 8.6884 16.5622 8.54687ZM15.4447 2.91062L14.6954 2.16038C14.6823 2.14731 14.6668 2.13694 14.6497 2.12986C14.6326 2.12278 14.6143 2.11914 14.5959 2.11914C14.5774 2.11914 14.5591 2.12278 14.542 2.12986C14.5249 2.13694 14.5094 2.14731 14.4964 2.16038L12.5738 4.08202C11.5139 3.54062 10.3226 3.26992 9.00004 3.26992C5.62152 3.26992 3.10082 5.02949 1.43793 8.54863C1.37109 8.69016 1.33643 8.84474 1.33643 9.00126C1.33643 9.15779 1.37109 9.31237 1.43793 9.4539C2.10227 10.8531 2.90207 11.9747 3.83735 12.8185L1.97723 14.6781C1.95088 14.7045 1.93607 14.7402 1.93607 14.7775C1.93607 14.8148 1.95088 14.8506 1.97723 14.8769L2.72764 15.6273C2.75401 15.6537 2.78976 15.6685 2.82704 15.6685C2.86432 15.6685 2.90008 15.6537 2.92645 15.6273L15.4447 3.1096C15.4578 3.09654 15.4682 3.08103 15.4752 3.06396C15.4823 3.04689 15.486 3.02859 15.486 3.01011C15.486 2.99163 15.4823 2.97333 15.4752 2.95626C15.4682 2.93919 15.4578 2.92368 15.4447 2.91062ZM2.62445 9.00038C4.08871 5.97343 6.16469 4.53554 9.00004 4.53554C9.95875 4.53554 10.8305 4.70007 11.6213 5.03458L10.3855 6.27033C9.80032 5.95807 9.13022 5.84219 8.47411 5.93976C7.818 6.03734 7.21063 6.3432 6.74159 6.81224C6.27255 7.28129 5.96668 7.88866 5.86911 8.54477C5.77153 9.20088 5.88742 9.87097 6.19967 10.4562L4.7333 11.9226C3.92172 11.2063 3.22211 10.2358 2.62445 9.00038ZM6.96098 9.00038C6.96129 8.69042 7.03471 8.3849 7.17527 8.10864C7.31584 7.83238 7.51959 7.59318 7.76998 7.41046C8.02036 7.22774 8.31032 7.10666 8.61629 7.05706C8.92226 7.00745 9.23561 7.03072 9.5309 7.12497L7.05432 9.60156C6.99224 9.40721 6.96075 9.2044 6.96098 9.00038Z"
        fill="#434343"
      />
      <path
        d="M8.92989 10.969C8.86907 10.969 8.80913 10.9662 8.74971 10.9607L7.82124 11.8892C8.37968 12.1031 8.98811 12.1506 9.57298 12.026C10.1579 11.9015 10.6941 11.6102 11.117 11.1873C11.5398 10.7645 11.8311 10.2282 11.9557 9.64333C12.0802 9.05846 12.0327 8.45002 11.8188 7.89159L10.8904 8.82006C10.8958 8.87947 10.8986 8.93942 10.8986 9.00024C10.8988 9.25881 10.8479 9.51488 10.7491 9.75381C10.6502 9.99273 10.5052 10.2098 10.3223 10.3927C10.1395 10.5755 9.92238 10.7205 9.68346 10.8194C9.44454 10.9183 9.18847 10.9691 8.92989 10.969Z"
        fill="#434343"
      />
    </svg>
  ),
  Eye: (props) => (
    <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.96098 9C6.96098 9.52214 7.1684 10.0229 7.53761 10.3921C7.90682 10.7613 8.40758 10.9688 8.92973 10.9688C9.45187 10.9688 9.95263 10.7613 10.3218 10.3921C10.6911 10.0229 10.8985 9.52214 10.8985 9C10.8985 8.47786 10.6911 7.9771 10.3218 7.60788C9.95263 7.23867 9.45187 7.03125 8.92973 7.03125C8.40758 7.03125 7.90682 7.23867 7.53761 7.60788C7.1684 7.9771 6.96098 8.47786 6.96098 9ZM16.5622 8.54648C14.8957 5.03613 12.3768 3.26953 9.00004 3.26953C5.62152 3.26953 3.10434 5.03613 1.43793 8.54824C1.37109 8.68978 1.33643 8.84436 1.33643 9.00088C1.33643 9.1574 1.37109 9.31198 1.43793 9.45352C3.10434 12.9639 5.62328 14.7305 9.00004 14.7305C12.3786 14.7305 14.8957 12.9639 16.5622 9.45176C16.6975 9.16699 16.6975 8.83652 16.5622 8.54648ZM8.92973 12.0938C7.22113 12.0938 5.83598 10.7086 5.83598 9C5.83598 7.29141 7.22113 5.90625 8.92973 5.90625C10.6383 5.90625 12.0235 7.29141 12.0235 9C12.0235 10.7086 10.6383 12.0938 8.92973 12.0938Z"
        fill="#434343"
      />
    </svg>
  ),
  Hourglass: (props) => (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icone status">
        <path
          id="Vector"
          d="M11.695 4.605V2.26H13.2C13.277 2.26 13.34 2.197 13.34 2.12V1.14C13.34 1.063 13.277 1 13.2 1H2.14C2.063 1 2 1.063 2 1.14V2.12C2 2.197 2.063 2.26 2.14 2.26H3.645V4.605C3.645 6.03125 4.387 7.286 5.507 8C4.387 8.714 3.645 9.96875 3.645 11.395V13.74H2.14C2.063 13.74 2 13.803 2 13.88V14.86C2 14.937 2.063 15 2.14 15H13.2C13.277 15 13.34 14.937 13.34 14.86V13.88C13.34 13.803 13.277 13.74 13.2 13.74H11.695V11.395C11.695 9.96875 10.953 8.714 9.833 8C10.953 7.286 11.695 6.03125 11.695 4.605ZM10.435 11.395V13.74H4.905V11.395C4.905 10.6565 5.192 9.96175 5.71525 9.44025C6.23675 8.917 6.9315 8.63 7.67 8.63C8.4085 8.63 9.10325 8.917 9.62475 9.44025C10.148 9.96175 10.435 10.6565 10.435 11.395ZM10.435 4.605C10.435 5.3435 10.148 6.03825 9.62475 6.55975C9.10325 7.083 8.4085 7.37 7.67 7.37C6.9315 7.37 6.23675 7.083 5.71525 6.55975C5.4574 6.30387 5.25299 5.99929 5.11389 5.66371C4.97479 5.32814 4.90379 4.96826 4.905 4.605V2.26H10.435V4.605Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  QuestionCircleFilled: (props) => (
    <svg {...props} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 0C3.63438 0 0.5 3.13438 0.5 7C0.5 10.8656 3.63438 14 7.5 14C11.3656 14 14.5 10.8656 14.5 7C14.5 3.13438 11.3656 0 7.5 0ZM7.5 11.0625C7.15469 11.0625 6.875 10.7828 6.875 10.4375C6.875 10.0922 7.15469 9.8125 7.5 9.8125C7.84531 9.8125 8.125 10.0922 8.125 10.4375C8.125 10.7828 7.84531 11.0625 7.5 11.0625ZM8.48281 7.63281C8.34131 7.68746 8.21955 7.78347 8.13343 7.90834C8.04731 8.03321 8.00081 8.18113 8 8.33281V8.6875C8 8.75625 7.94375 8.8125 7.875 8.8125H7.125C7.05625 8.8125 7 8.75625 7 8.6875V8.35156C7 7.99062 7.10469 7.63437 7.31094 7.3375C7.5125 7.04687 7.79375 6.825 8.125 6.69844C8.65625 6.49375 9 6.04844 9 5.5625C9 4.87344 8.32656 4.3125 7.5 4.3125C6.67344 4.3125 6 4.87344 6 5.5625V5.68125C6 5.75 5.94375 5.80625 5.875 5.80625H5.125C5.05625 5.80625 5 5.75 5 5.68125V5.5625C5 4.94844 5.26875 4.375 5.75625 3.94844C6.225 3.5375 6.84375 3.3125 7.5 3.3125C8.15625 3.3125 8.775 3.53906 9.24375 3.94844C9.73125 4.375 10 4.94844 10 5.5625C10 6.46562 9.40469 7.27812 8.48281 7.63281Z"
        fill="currentColor"
      />
    </svg>
  ),
  QuestionMarkOutlined: (props) => (
    <svg {...props} viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2734 3.04492C10 2.44727 9.61133 1.91016 9.11523 1.45117C8.10742 0.515625 6.76953 0 5.35156 0C3.93359 0 2.5957 0.515625 1.58789 1.44922C1.0918 1.91016 0.703125 2.44531 0.429688 3.04492C0.144531 3.66992 0 4.33203 0 5.01562V5.54297C0 5.66406 0.0976562 5.76172 0.21875 5.76172H1.27344C1.39453 5.76172 1.49219 5.66406 1.49219 5.54297V5.01562C1.49219 3.07227 3.22266 1.49219 5.35156 1.49219C7.48047 1.49219 9.21094 3.07227 9.21094 5.01562C9.21094 5.8125 8.92773 6.5625 8.39062 7.1875C7.85937 7.80664 7.10938 8.25 6.2793 8.4375C5.80469 8.54492 5.37695 8.8125 5.07422 9.19531C4.77254 9.57682 4.60811 10.0488 4.60742 10.5352V11.1484C4.60742 11.2695 4.70508 11.3672 4.82617 11.3672H5.88086C6.00195 11.3672 6.09961 11.2695 6.09961 11.1484V10.5352C6.09961 10.2285 6.3125 9.95898 6.60742 9.89258C7.74805 9.63477 8.7832 9.01953 9.52344 8.16016C9.89648 7.72461 10.1875 7.24023 10.3887 6.71484C10.5977 6.16992 10.7031 5.59766 10.7031 5.01562C10.7031 4.33203 10.5586 3.66797 10.2734 3.04492V3.04492ZM5.35156 12.9297C4.74805 12.9297 4.25781 13.4199 4.25781 14.0234C4.25781 14.627 4.74805 15.1172 5.35156 15.1172C5.95508 15.1172 6.44531 14.627 6.44531 14.0234C6.44531 13.4199 5.95508 12.9297 5.35156 12.9297Z"
        fill="#595959"
      />
    </svg>
  ),
  ExclamationCircleFilled: (props) => (
    <svg {...props} viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM6.5 3.625C6.5 3.55625 6.55625 3.5 6.625 3.5H7.375C7.44375 3.5 7.5 3.55625 7.5 3.625V7.875C7.5 7.94375 7.44375 8 7.375 8H6.625C6.55625 8 6.5 7.94375 6.5 7.875V3.625ZM7 10.5C6.80374 10.496 6.61687 10.4152 6.47948 10.275C6.3421 10.1348 6.26515 9.9463 6.26515 9.75C6.26515 9.5537 6.3421 9.36522 6.47948 9.225C6.61687 9.08478 6.80374 9.00401 7 9C7.19626 9.00401 7.38313 9.08478 7.52052 9.225C7.6579 9.36522 7.73485 9.5537 7.73485 9.75C7.73485 9.9463 7.6579 10.1348 7.52052 10.275C7.38313 10.4152 7.19626 10.496 7 10.5Z"
        fill="#currentColor"
      />
    </svg>
  ),
  ServerWarningOutline: (props) => (
    <svg {...props} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 19C12.792 19 11 17.208 11 15C11 14.728 11.024 14.456 11.08 14.2H4.6C3.72 14.2 3 14.92 3 15.8V17.4C3 18.28 3.72 19 4.6 19H15Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.456 12.992C17.768 11.8 16.472 11 15 11C13.36 11 11.952 11.992 11.328 13.4H4.6C3.72 13.4 3 12.68 3 11.8V10.2C3 9.31998 3.72 8.59998 4.6 8.59998H17.4C18.28 8.59998 19 9.31998 19 10.2V11.8C19 12.272 18.792 12.704 18.456 12.992Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4 7.8H4.6C3.72 7.8 3 7.08 3 6.2V4.6C3 3.72 3.72 3 4.6 3H17.4C18.28 3 19 3.72 19 4.6V6.2C19 7.08 18.28 7.8 17.4 7.8Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 7.79999H3V8.59999H19V7.79999Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3999 4.59998V6.19998"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M7.80005 4.59998V6.19998"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M5.3999 10.2V11.8"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M7.80005 10.2V11.8"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M5.3999 15.8V17.4"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M7.80005 15.8V17.4"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M11.08 14.2C11.136 13.92 11.224 13.656 11.328 13.4H4.6H3V14.2H4.6H11.08Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 19C17.2091 19 19 17.2091 19 15C19 12.7909 17.2091 11 15 11C12.7909 11 11 12.7909 11 15C11 17.2091 12.7909 19 15 19Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 17.3999V12.5999"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinejoin="round"
      />
      <path
        d="M15 17.4L15.8 16.6H14.2L15 17.4Z"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeLinecap="round"
      />
      <path
        d="M15 16.6H15.008"
        stroke="black"
        strokeOpacity="0.75"
        strokeWidth="0.956165"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DoubleArrowRightOutline: (props) => (
    <svg {...props} viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1536 11.0684L17.9869 6.06836L12.1536 1.06836"
        stroke="#262626"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8203 6.06836L7.98698 1.06836V4.40169C7.98698 4.40169 3.64415 3.88503 2.11989 6.87669C1.02 8.92669 1.3491 10.5434 1.42705 10.81C1.42705 10.81 3.6567 7.30169 7.98698 7.73503V11.0684L13.8203 6.06836Z"
        stroke="#262626"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PrintOutline: (props) => (
    <svg {...props} viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.32015 12.0383H10.9868L11.8202 16.205H3.48682L4.32015 12.0383Z"
        stroke="#262626"
        strokeWidth="1.2"
      />
      <path
        d="M4.32031 1.20502H10.987V4.53835H4.32031V1.20502Z"
        stroke="#262626"
        strokeWidth="1.2"
      />
      <path
        d="M0.986816 6.53833C0.986816 5.43376 1.88225 4.53833 2.98682 4.53833H12.3202C13.4247 4.53833 14.3201 5.43376 14.3201 6.53833V12.0383H0.986816V6.53833Z"
        stroke="#262626"
        strokeWidth="1.2"
      />
      <path d="M4.32031 9.53833H10.987" stroke="#262626" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M10.1536 7.03833H10.9869" stroke="#262626" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
};

export type OneToneIconName = keyof typeof OneToneIcons;

export default OneToneIcons;
